module.exports = ".switch-team-modal .modal-footer {\n  text-align: center !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/rFF/sub-form/sub-form.component.scss
// module id = ./src/app/rFF/sub-form/sub-form.component.scss
// module chunks = main